<template lang="pug">
	.card-body
		.row
			.col-xs-12.col-sm-12.col-md-6.col-lg-6
				div
					.card.card-success.mb-2
						.card-body.bg-light
							b Representante o persona de contacto
							.input-group.mt-2
								.input-group-prepend
									.input-group-text
										span.fa.fa-user
								input.form-control(type="text" v-model="cliente.nombre" placeholder="Nombre y apellidos", :disabled="!permisoEditar")
					.card.mb-2
						.card-body
							b Dirección
							div(v-if="cliente.place_id")
								span {{cliente.direccion.direccion_formateada}}
								.form-group
									label.mt-2
										b Anotaciones extra
									textarea.form-control.form-control-sm(v-model="cliente.direccion.indicaciones", placeholder="Ej: 2º planta, puerta B")
								.text-center(v-if="permisoEditar")
									button.btn.btn-primary(@click="modificarDireccion()")
										span.fa.fa-edit.mr-2
										| Modificar
							div(v-else)
								.input-group
									input.form-control(type="text" placeholder="Busca en google por nombre o dirección" v-model="campoGoogle" @keypress.enter="buscaEnGoogle", @keypress="buscadoGoogle = false")
									.input-group-append
										button.btn.btn-primary(@click="buscaEnGoogle")
											span.fa.fa-search
								div.mt-2(style="font-size:0.8em;")
									i(style="cursor: pointer;", @click="campoGoogle = cliente.direccion.indicaciones", v-if="cliente.direccion.indicaciones") <u>Sugerencia:</u> {{cliente.direccion.indicaciones}}
									i(style="cursor: pointer;", @click="campoGoogle = cliente.direccion.direccion", v-else-if="cliente.direccion.direccion") <u>Sugerencia:</u> {{cliente.direccion.direccion}}
									i(style="cursor: pointer;", @click="campoGoogle = cliente.direccion.direccion_formateada", v-else-if="cliente.direccion.direccion_formateada") <u>Sugerencia:</u> {{cliente.direccion.direccion_formateada}}
									i(style="cursor: pointer;", @click="campoGoogle = parseaDireccion(cliente.direccion)", v-else) <u>Sugerencia:</u> {{parseaDireccion(cliente.direccion)}}
					.card
						.card-body
							b Teléfono(s) | E-mail(s)
							.input-group.input-group-sm(v-for="(tel, index) in cliente.telefonos" :key="'tel' + index" style="margin-top:5px;")
								.input-group-prepend
									span.input-group-text.fa.fa-w.fa-phone
								input.form-control(type="text" placeholder="Teléfono" v-model="cliente.telefonos[index].telefono", :disabled="!permisoEditar")
								.input-group-append(v-if="permisoEditar")
									button.btn.btn-danger.btn-sm(@click="quitaTel(index)")
										span.fa.fa-trash
							.input-group.input-group-sm(v-for="(tel, index) in cliente.emails" :key="'email' + index" style="margin-top:5px;")
								.input-group-prepend
									span.input-group-text.fa.fa-w.fa-envelope
								input.form-control(type="text" placeholder="E-mail" v-model="cliente.emails[index].email", :disabled="!permisoEditar")
								.input-group-append(v-if="permisoEditar")
									button.btn.btn-danger.btn-sm(@click="quitaEmail(index)")
										span.fa.fa-trash
						.card-footer(v-if="permisoEditar")
							button.m-1.btn.btn-sm.btn-success(@click="addTel()")
								span.fa.fa-plus.mr-2
								| Teléfono

							button.m-1.btn.btn-sm.btn-success(@click="addEmail()")
								span.fa.fa-plus.mr-2
								| E-mail
			.col-xs-12.col-sm-12.col-md-6.col-lg-6
				div(v-if="!cliente.place_id")
					div(v-if="resultadosGoogle.length > 0")
						img(src="../../../static/powered_by_google_on_white.png", style="position:absolute;display:block;top: 0px; right: 15px;")
						b Selecciona un elemento
						table.table.table-striped.mt-3
							tbody
								tr(v-for="direccion in resultadosGoogle" :key="direccion.place_id")
									td
										div(v-if="direccion.name")
											b {{direccion.name}}
										span {{direccion.formatted_address}}
									td
										button.btn.btn-sm.btn-primary(@click="seleccionaPlace(direccion.place_id)")
											span.fa.fa-check
					div.text-center(v-else-if="!buscadoGoogle")
						h4.text-info(style="margin-top: 100px;")
							span.fa.fa-search
							br
							| Realiza una búsqueda
					div.text-center(v-else)
						h4.text-danger(style="margin-top: 100px;")
							span.fa.fa-search
							br
							| Sin resultados
				div(id="map", v-show="cliente.place_id")
</template>

<script>
export default {
	props: ['cliente', 'permisoEditar'],
	data () {
		return {
			map: null,
			marcador: null,
			campoGoogle: null,
			resultadosGoogle: [],
			buscadoGoogle: false
		}
	},
	watch: {
		cliente: function (newVal) {
			if (newVal.place_id) {
				this.muestraMapa()
			}
		}
	},
	mounted () {
		if (this.cliente.place_id) {
			this.muestraMapa()
		}
	},
	methods: {
		modificarDireccion () {
			this.cliente.place_id = null
			this.resultadosGoogle = []
		},
		buscaEnGoogle () {
			this.cliente.place_id = null
			this.resultadosGoogle = []
			this.$http.post('gestion-clientes/php/api/buscaEnGoogle.php', {q: this.campoGoogle})
				.then(res => {
					this.resultadosGoogle = res.data
					this.buscadoGoogle = true
				})
				.catch(e => {
					console.error(e.response)
				})
		},

		seleccionaPlace (placeid) {
			this.$http.get('gestion-clientes/php/api/detallesGoogle.php?place_id=' + placeid)
				.then(res => {
					this.cliente.direccion.direccion_formateada = res.data.formatted_address
					this.cliente.place_id = placeid
					this.cliente.lat = res.data.geometry.location.lat
					this.cliente.long = res.data.geometry.location.lng

					// Construye mapa
					this.muestraMapa()

					if (res.data.formatted_phone_number) {
						const tel = res.data.formatted_phone_number.trim().replace(/\s/ig, '')
						for (let i = 0; i < this.cliente.telefonos.length; i++) {
							let telAnterior
							try {
								telAnterior = this.cliente.telefonos[i].telefono.toString()
							} catch (e) {
								continue
							}
							if (telAnterior.trim().replace(/\s/ig, '') === tel) {
								this.cliente.telefonos[i].telefono = res.data.formatted_phone_number.trim()
								return
							}
						}
					}

					this.cliente.telefonos.push({
						ID_telefono: null,
						nombre: null,
						telefono: res.data.formatted_phone_number
					})
				})
				.catch(e => {
					console.error(e.response)
				})
		},

		muestraMapa () {
			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('map'), {
				center: {lat: this.cliente.lat, lng: this.cliente.long},
				zoom: 15
			})

			if (this.marcador) {
				this.marcador.setMap(null)
			}

			// Añadimos el marcador
			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: {lat: this.cliente.lat, lng: this.cliente.long},
				title: this.cliente.cliente,
				map: this.map
			})
		},
		addTel () {
			this.cliente.telefonos.push({
				ID_telefono: null,
				telefono: null,
				nombre: null
			})
		},
		quitaTel (i) {
			this.cliente.telefonos.splice(i, 1)
		},

		addEmail () {
			this.cliente.emails.push({
				ID_email: null,
				email: null,
				nombre: null
			})
		},

		quitaEmail (i) {
			this.cliente.emails.splice(i, 1)
		},
		parseaDireccion (direccion) {
			if (direccion.via) {
				let dir = ''
				dir = direccion.via
				dir = (direccion.numero) ? dir + ', nº ' + direccion.numero : dir
				dir = (direccion.esc) ? dir + ', esc. ' + direccion.esc : dir
				dir = (direccion.piso) ? dir + ', ' + direccion.piso + ' piso' : dir
				dir = (direccion.puerta) ? dir + ' ' + direccion.puerta : dir
				dir = (direccion.cp) ? dir + ' ' + 'C.P. ' + direccion.cp : dir
				dir = (direccion.localidad) ? dir + ' ' + direccion.localidad : dir
				dir = (direccion.region) ? dir + ' ' + direccion.region : dir
				dir = (direccion.pais) ? dir + ' ' + direccion.pais.toUpperCase() : dir
				dir = (direccion.indicaciones) ? dir + ' - ' + direccion.indicaciones : dir
				return dir
			} else {
				return direccion.indicaciones
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/components/editor/contacto.vue